import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios';
import CryptoJS from 'crypto-js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Print from 'vue-print-nb';

Vue.use(Print);

Vue.config.productionTip = false;

import { setAxiosInstance } from '@/api/knowledge';
import { setAxiosInstance2 } from '@/api/exam';
import { setAxiosInstance3 } from '@/api/teacher_dashboard';

import 'katex/dist/katex.min.css';

const testUrl = 'http://localhost:8000';

// const web = 'http://42.194.183.221:90/api';
const web = 'https://gnnuhwr.cloud/api';

// const trueUrl = testUrl;
const trueUrl = web;

export default trueUrl;

const API_SECRET_KEY = 'BuYaoGaoWoHaoMa-250250!@#MMD'
const API_CLIENT_ID = 'vue-frontend-physics-exercise'

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 生成时间戳
  const timestamp = Date.now();
  const nonce = Math.random().toString(36).substring(2, 15); // 添加随机数
  
  // 只使用路径部分，不包含查询参数
  const url = new URL(config.url, config.baseURL);
  const path = url.pathname; // 只使用路径，忽略查询参数
  
  // 构建签名字符串 - 只包含方法、路径、时间戳和随机数
  const signString = `${config.method.toUpperCase()}${path}${timestamp}${nonce}`;
  
  const signature = CryptoJS.HmacSHA256(signString, API_SECRET_KEY).toString();
  
  // 添加安全头
  config.headers['X-API-Client'] = API_CLIENT_ID;
  config.headers['X-API-Timestamp'] = timestamp;
  config.headers['X-API-Signature'] = signature;
  config.headers['X-API-Nonce'] = nonce;

  // 添加Token
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  // 添加 CSRF 令牌
  // const csrftoken = getCookie('csrftoken');
  // if (csrftoken) {
  //   config.headers['X-CSRFToken'] = csrftoken;
  // }
  
  // 调试输出
  // console.log("Frontend sign string:", signString);
  // console.log("Frontend signature:", signature);
  
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 添加响应拦截器处理Token过期
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        // Token失效，清除本地存储并跳转到登录页
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // 如果当前不是登录页，则跳转到登录页
        if (!window.location.pathname.includes('/login')) {
          // 获取当前页面的完整路径（包含查询参数）
          const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
          // 跳转到登录页，并附上要返回的地址
          window.location.href = `/login?returnUrl=${returnUrl}`;
        }
      }
    }
    return Promise.reject(error);
  }
);

// 获取 cookie 函数
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}
setAxiosInstance(axios);
setAxiosInstance2(axios);
setAxiosInstance3(axios);

axios.defaults.withCredentials = true; // 跨域请求发送cookies
Vue.prototype.$axios = axios;

axios.defaults.baseURL = trueUrl;
// 定义全局变量（后端路由），通过this.$apiUrl访问
Vue.prototype.$apiUrl = trueUrl;
Vue.prototype.$webUrl = web;

new Vue({
  router,
  store,
  el: '#app',
  render: (h) => h(App),
}).$mount("#app");
